import { render } from "./VillageFriends.vue?vue&type=template&id=3d138ea8&scoped=true"
import script from "./VillageFriends.vue?vue&type=script&lang=js"
export * from "./VillageFriends.vue?vue&type=script&lang=js"

import "./VillageFriends.vue?vue&type=style&index=0&id=3d138ea8&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d138ea8"]])

export default __exports__